var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 0.5C4.24083 0.5 0.5 4.24083 0.5 8.83333C0.5 13.4258 4.24083 17.1667 8.83333 17.1667C10.8304 17.1667 12.6645 16.4575 14.1019 15.2803L19.0775 20.2559C19.1543 20.3358 19.2462 20.3997 19.348 20.4437C19.4498 20.4877 19.5593 20.5109 19.6702 20.512C19.781 20.5132 19.891 20.4922 19.9937 20.4503C20.0963 20.4083 20.1896 20.3464 20.268 20.268C20.3464 20.1896 20.4083 20.0963 20.4503 19.9937C20.4922 19.891 20.5132 19.781 20.512 19.6702C20.5109 19.5593 20.4877 19.4498 20.4437 19.348C20.3997 19.2462 20.3358 19.1543 20.2559 19.0775L15.2803 14.1019C16.4575 12.6645 17.1667 10.8304 17.1667 8.83333C17.1667 4.24083 13.4258 0.5 8.83333 0.5ZM8.83333 2.16667C12.5251 2.16667 15.5 5.14157 15.5 8.83333C15.5 12.5251 12.5251 15.5 8.83333 15.5C5.14157 15.5 2.16667 12.5251 2.16667 8.83333C2.16667 5.14157 5.14157 2.16667 8.83333 2.16667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5f50c8e2ceb4e1b87b35b8627e5602a7.svg";
export { ForwardRef as ReactComponent };